import React from "react";
import "../css/FooterComponent.css";

const FooterComponent = () => {
    return (
        <div id="footer-container">
            <p>©2026 AlohaBowlsandTea. All Rights Reserved.</p>
        </div>
    )
}

export default FooterComponent;